import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=b4c8a51c&scoped=true"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"
import style0 from "./Offline.vue?vue&type=style&index=0&id=b4c8a51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8a51c",
  null
  
)

export default component.exports